/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * useDocumentTitle — sets the browser tab title for a page.
 *
 * S.6 (S390 FCR Pass 6): Every page previously showed "Shop DeskShare"
 * (wrong capitalization) regardless of which view was active, hurting
 * multi-tab usability, accessibility (screen readers announce the title),
 * and SEO.
 *
 * Usage:
 *   useDocumentTitle("My Products");
 *   // → sets <title>My Products — Deskshare</title>
 *
 * Pass `null` to let the index.html default ("Deskshare") remain unchanged
 * (useful for pages still being built).
 */

import { useEffect } from "react";

const BRAND = "Deskshare";

export function useDocumentTitle(pageTitle: string | null): void {
  useEffect(() => {
    if (!pageTitle) return;
    const previous = document.title;
    document.title = `${pageTitle} — ${BRAND}`;
    return () => {
      document.title = previous;
    };
  }, [pageTitle]);
}
